export default __webpack_public_path__ + "static/media/pppoe.8f12a424.png";